import { getStatusMark, getStatusStyle } from '@/lib/caseMeta';

type Props = {
  status: string;
  size?: 'sm' | 'md';
};

const StatusBadge = ({ status, size = 'sm' }: Props) => (
  <span
    className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border font-label font-medium ${getStatusStyle(
      status,
    )} ${size === 'sm' ? 'px-2.5 py-1 text-xs' : 'px-3 py-1.5 text-sm'}`}
  >
    <span className={`h-1.5 w-1.5 rounded-full ${getStatusMark(status)}`} aria-hidden="true" />
    {status}
  </span>
);

export default StatusBadge;